import { getStorageUrl } from "../../config/config";

export default function InvoiceRow({ 
  invoice, 
  onAnular, 
  onVerInvalidacion,
  onDescargarInvalidacion, // Mantener prop pero no usar
  isDownloadingInvalidacion, // Mantener prop pero no usar
  onReprint
}) {
  // Función para determinar el badge de estado
  const getEstadoBadge = () => {
    const estado = invoice.estado_dte;
    
    switch(estado) {
      case 'VALIDADO':
        return <span className="badge badge-success">✓ Validado</span>;
      case 'ANULADO':
        return <span className="badge badge-danger">✕ Anulado</span>;
      case 'RECHAZADO':
        return <span className="badge badge-danger">✗ Rechazado</span>;
      case 'PENDIENTE':
        return <span className="badge badge-warning">⏳ Pendiente</span>;
      default:
        return <span className="badge badge-secondary">{estado}</span>;
    }
  };

  // Función para determinar el tipo de DTE
  const getTipoDteBadge = () => {
    const tipo = invoice.tipo_documento;
    
    switch(tipo) {
      case '01':
        return <span className="badge badge-info" style={{ fontSize: '11px' }}>CF</span>;
      case '03':
        return <span className="badge badge-primary" style={{ fontSize: '11px' }}>CCF</span>;
      case '05':
        return <span className="badge badge-warning" style={{ fontSize: '11px' }}>NC</span>;
      default:
        return <span className="badge badge-secondary" style={{ fontSize: '11px' }}>{tipo}</span>;
    }
  };

  return (
    <tr style={{ opacity: invoice.estado_dte === 'ANULADO' ? 0.6 : 1 }}>
      <td>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span className="badge badge-primary">
            {invoice.codigo_generacion ?? "N/A"}
          </span>
          {getTipoDteBadge()}
        </div>
      </td>
      
      <td>{invoice.sale?.client?.nombre ?? "Cliente no disponible"}</td>
      
      <td>
        {invoice.fecha_emision
          ? new Date(invoice.fecha_emision).toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            })
          : "—"}
      </td>

      {/* Estado */}
      <td>
        {getEstadoBadge()}
      </td>

      {/* PDF */}
      <td style={{ textAlign: 'center' }}>
        {invoice.pdf_path ? (
          <a
            href={getStorageUrl(invoice.pdf_path, "pdf")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success btn-sm"
          >
            📄 PDF
          </a>
        ) : (
          <span className="badge badge-secondary">No disponible</span>
        )}
      </td>

      {/* JSON - SIN BOTÓN DE INVALIDACIÓN */}
      <td style={{ textAlign: 'center' }}>
        {invoice.json_path ? (
          <a
            href={getStorageUrl(invoice.json_path, "json")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-warning btn-sm"
          >
            📋 JSON
          </a>
        ) : (
          <span className="badge badge-secondary">No disponible</span>
        )}
      </td>

      {/* Anular / Ver Invalidación */}
      <td style={{ textAlign: 'center' }}>
        {invoice.estado_dte === 'VALIDADO' ? (
          <button
            className="btn btn-danger btn-sm"
            onClick={() => onAnular(invoice)}
            title="Anular factura"
          >
            🗑️ Anular
          </button>
        ) : invoice.estado_dte === 'ANULADO' ? (
          <button
            className="btn btn-info btn-sm"
            onClick={() => onVerInvalidacion(invoice)}
            title="Ver detalles de anulación"
          >
            🔍 Ver
          </button>
        ) : (
          <span className="badge badge-secondary">—</span>
        )}
      </td>
      {/* Reimprimir */}
      <td style={{ textAlign: 'center' }}>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => onReprint(invoice)}
          title="Reimprimir ticket"
        >
          🖨️ Reimprimir
        </button>
      </td>
    </tr>
  );
}